import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AuthService } from '../../../services/auth/auth.service';

@Component({
  selector: 'app-descuentos',
  templateUrl: './descuentos.component.html',
  styleUrls: ['./descuentos.component.css']
})
export class DescuentosComponent implements OnInit {
  safeUrl: SafeResourceUrl;

  constructor(
    private authService: AuthService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    const acccessToken = this.authService.getToken();

    const iframeUrl = `${environment.ADMIN_URL}dashboard/descuentos?token=${acccessToken}`;
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(iframeUrl);
  }
}


// WEBPACK FOOTER //
// /app/src/app/pages/admin/descuentos/descuentos.component.ts